<template>
  <base-section
    :id="id"
  >
    <v-container>
      <base-subheading
        align="center"
        :title="item.title"
        class="text-uppercase"
        space="2"
      />
      <template v-if="!item.isError">
        <v-row
          class="mt-5"
          align="center"
          justify="center"
        >
          <!-- <base-img
            :src="require(`@/assets/${item.image}`)"
            max-height="300"
            width="100%"
          /> -->
          <base-img
            :src="item.image"
            max-height="300"
            width="100%"
          />
        </v-row>

        <v-row
          class="mt-5"
          align="start"
          justify="center"
        >
          <v-col
            cols="12"
            md="12"
          >
            <h3
              class="title font-weight-bold mb-4 text-left"
            >
              DESCRIPCIÓN DEL PUESTO
            </h3>
            <P
              class="base-body body-1 grey--text text--darken-1 text-left mb-12"
              v-html="item.description"
            >
              <!-- {{ item.description }} -->
            </P>
          </v-col>
        </v-row>

        <base-curriculum-items
          v-for="(feature, f) in item.features"
          :key="f"
          :title="feature.title"
          :iconprincipal="feature.iconPrincipal"
          :iconline="feature.iconLineal"
          :lines="feature"
        />

        <base-section
          id="curriculum-alt"
          space="56"
        >
          <v-container>
            <v-row justify="center">
              <v-col
                cols="12"
                md="8"
              >
                <base-curriculum-form :referencia="slug" />
              </v-col>
            </v-row>
          </v-container>
        </base-section>
      </template>
    </v-container>
  </base-section>
</template>

<script>
  // Mixins
  import Works from '@/mixins/works'
  export default {
    name: 'SectionEmpleoSlug',

    mixins: [
      Works,
    ],

    props: {
      id: {
        type: String,
        default: 'empleo-slug',
      },
    },

    data: () => ({
      /* itemsOld: [
        {
          image: 'works/solar.jpg',
          title: 'Oficial de energías renovables (H/M)',
          slug: 'oficial-renovables',
          description: 'Se requieren profesionales técnicos vinculados al sector de las Energías renovables (Solar Fotovoltaica y Aerotermia) para la ejecución de proyectos de nueva instalación, mantenimiento, detección de averías y reparación en la provincia de Sevilla.',
          features: [
            {
              title: 'Formación Mínima',
              iconPrincipal: 'mdi-school',
              iconLineal: 'mdi-school-outline',
              literal: null,
              literalExtend: [
                'Técnico superior en Instalaciones Eléctricas y Automáticas.',
                'Técnico superior en Sistemas electrotécnicos y automatizados.',
              ],
            },
            {
              title: 'Requisitos Mínimos',
              iconPrincipal: 'mdi-clipboard-list',
              iconLineal: 'mdi-certificate',
              literal: 'Estar en posesión de la formación exigida en materia de Prevención de Riesgos Laborales Vigente.',
              literalExtend: [
                'Curso Específico de PRL electricidad (6 horas/8 horas/20 horas).',
                'Curso Básico PRL 50 / 60horas.',
                'Curso de PRL Trabajos en Altura.',
                'Curso de PRL Plataformas Elevadoras.',
              ],
            },
            {
              title: 'Experiencia',
              iconPrincipal: 'mdi-briefcase',
              iconLineal: 'mdi-account-hard-hat',
              literal: '+5 años demostrables en diversos tipos de obras:',
              literalExtend: [
                'Instalación de estructuras fotovoltaicas e instalación de placas solares (preferentemente).',
                'Instalaciones eléctricas integrales en locales comerciales e industriales, edificios, almacenes y viviendas.',
                'Instalación de Sistemas de telecomunicaciones.',
                'Instalación de Grupos electrógenos, equipos de climatización y Aerotermia.',
              ],
            },
            {
              title: 'Competencias',
              iconPrincipal: 'mdi-podium',
              iconLineal: 'mdi-podium-gold',
              literal: null,
              literalExtend: [
                'Autonomía y responsabilidad en el trabajo.',
                'Capacidad de trabajo en equipo.',
                'Actitud ambiciosa y positiva.',
                'Interpretación de planos técnicos de ubicación e instalación.',
                'Capacidad resolutiva ante circunstancias adversas.',
              ],
            },
            {
              title: 'Condiciones Laborales',
              iconPrincipal: 'mdi-file-document-multiple',
              iconLineal: 'mdi-file-document-outline',
              literal: null,
              literalExtend: [
                'La jornada laboral es de Lunes a Viernes, jornada completa.',
                'El horario es variable en el intervalo desde las 7:00h hasta las 18:00h.',
                'Contrato eventual por circunstancias de la producción con posibilidad de conversión a indefinido.',
                'Se valorarán sus cualidades, aptitudes y actitud para la continuidad y la evolución profesional.',
                'Salarios sujetos al Convenio del Metal: 1.250,00€-1.450,00€ brutos al mes, según categoría.',
              ],
            },
            {
              title: 'Otros Requisitos',
              iconPrincipal: 'mdi-format-list-bulleted-square',
              iconLineal: 'mdi-format-list-checkbox',
              literal: null,
              literalExtend: [
                'Residencia en Sevilla.',
                'Se valorará la disponibilidad geográfica (Andalucía).',
                'Vehículo Propio.',
              ],
            },
          ],
        },
        {
          image: 'works/electricidad_02.jpg',
          title: 'Oficial Electricidad (H/M)',
          slug: 'oficial-electricidad',
          description: 'Se requieren profesionales técnicos vinculados al sector de la Electricidad para la ejecución de proyectos de nueva instalación, mantenimiento, detección de averías y reparación en la provincia de Sevilla.',
          features: [
            {
              title: 'Formación Mínima',
              iconPrincipal: 'mdi-school',
              iconLineal: 'mdi-school-outline',
              literal: null,
              literalExtend: [
                'Técnico superior en Instalaciones Eléctricas y Automáticas.',
                'Técnico superior en Sistemas electrotécnicos y automatizados.',
              ],
            },
            {
              title: 'Requisitos Mínimos',
              iconPrincipal: 'mdi-clipboard-list',
              iconLineal: 'mdi-certificate',
              literal: 'Estar en posesión de la formación exigida en materia de Prevención de Riesgos Laborales Vigente.',
              literalExtend: [
                'Curso Específico de PRL electricidad (6 horas/8 horas/20 horas).',
                'Curso Básico PRL 50 / 60horas.',
                'Curso de PRL Trabajos en Altura.',
                'Curso de PRL Plataformas Elevadoras.',
              ],
            },
            {
              title: 'Experiencia',
              iconPrincipal: 'mdi-briefcase',
              iconLineal: 'mdi-account-hard-hat',
              literal: '+5 años demostrables en diversos tipos de obras:',
              literalExtend: [
                'Instalaciones eléctricas integrales en locales comerciales e industriales, edificios, almacenes y viviendas.',
                'Instalación de Sistemas de telecomunicaciones.',
                'Instalación de Grupos electrógenos, equipos de climatización y Aerotermia.',
              ],
            },
            {
              title: 'Competencias',
              iconPrincipal: 'mdi-podium',
              iconLineal: 'mdi-podium-gold',
              literal: null,
              literalExtend: [
                'Autonomía y responsabilidad en el trabajo.',
                'Capacidad de trabajo en equipo.',
                'Actitud ambiciosa y positiva.',
                'Interpretación de planos técnicos de ubicación e instalación.',
                'Capacidad resolutiva ante circunstancias adversas.',
              ],
            },
            {
              title: 'Condiciones Laborales',
              iconPrincipal: 'mdi-file-document-multiple',
              iconLineal: 'mdi-file-document-outline',
              literal: null,
              literalExtend: [
                'La jornada laboral es de Lunes a Viernes, jornada completa.',
                'El horario es variable en el intervalo desde las 7:00h hasta las 18:00h.',
                'Contrato eventual por circunstancias de la producción con posibilidad de conversión a indefinido.',
                'Se valorarán sus cualidades, aptitudes y actitud para la continuidad y la evolución profesional.',
                'Salarios sujetos al Convenio del Metal: 1.250,00€-1.450,00€ brutos al mes, según categoría.',
              ],
            },
            {
              title: 'Otros Requisitos',
              iconPrincipal: 'mdi-format-list-bulleted-square',
              iconLineal: 'mdi-format-list-checkbox',
              literal: null,
              literalExtend: [
                'Residencia en Sevilla.',
                'Se valorará la disponibilidad geográfica (Andalucía).',
                'Vehículo Propio.',
              ],
            },
          ],
        }, // End Item
      ], */
    }),
  }
</script>
